import React, { ReactNode } from "react"

import { CountDown } from "../Headers/NewHeader/RightSection/CountDown"
import closeBtn from "./img/arrowClose.svg"
import blackArrow from "./img/arrowBlack.svg"
import { ClockImage } from "./img/ClockImage"
import { GiftImage } from "./img/GiftImage"
import type { TImgTimerType } from "../FormPKW/types"
import * as styles from "./timer.module.scss"
import { HalvaCard } from "./img/HalvaCard"
import { NewYearTree } from "./img/NewYearTree"
import { NewYearSquirrel } from "./img/NewYearSquirrel"
import { StickerImage } from "./img/StickerImage"
import PawCitty from "./img/Image_Paw.svg"
import BlueGift from "./img/Image_Gift.svg"

const defaultDescription = (
  <>
    Успейте получить <span>подарок</span>: <br />
    подписку «Халва.Десятка» на месяц <br />
    <span>бесплатно!</span>
  </>
)

const anotherTimeDescription = (
  <>
    Играйте в игру с 04.12 до 14.01,
    <br />
    получайте подарки и участвуйте в<br />
    розыгрыше главного <br />
    приза – автомобиля
  </>
)

const stickerDescription = (
  <>
    Количество стикеров ограничено.
    <br />
    <span>Успейте получить свой!</span>
  </>
)

type TimerProps = {
  isNewYear?: boolean
  countDownTime?: number
  imgTimerType?: TImgTimerType
  timerDescription?: ReactNode
  anotherTimerDescr?: ReactNode
  stickerHalvaTimer?: boolean
  isPawCitty?: boolean
}

const Timer = ({
  countDownTime,
  imgTimerType,
  timerDescription = defaultDescription,
  isNewYear = false,
  anotherTimerDescr = anotherTimeDescription,
  stickerHalvaTimer,
  isPawCitty,
}: TimerProps) => {
  if (stickerHalvaTimer) {
    return (
      <div className={styles.root}>
        <div className={styles.clsBtn}>
          <img src={closeBtn} className={styles.closeBtn} alt="closeBtn" />
        </div>
        <div className={styles.wrapper}>
          {imgTimerType === "halva_card" ? (
            <HalvaCard alt="halva card" className={styles.cardImg} />
          ) : (
            <ClockImage alt="clock" className={styles.clockImgStickerMode} />
          )}

          <div className={styles.timer}>
            <CountDown countDownTime={countDownTime} />
          </div>
          <p className={styles.descr}>{stickerDescription}</p>
        </div>
        <StickerImage alt="sticker" className={styles.stickerImg} />
      </div>
    )
  }

  if (isNewYear) {
    return (
      <div className={styles.rootNY}>
        <div className={styles.clsBtn}>
          <img src={blackArrow} className={styles.closeBtn} alt="closeBtn" />
        </div>
        <div className={styles.wrapperNY}>
          <NewYearTree alt="new year tree" className={styles.treeImg} />
          <div className={styles.timerNY}>
            <CountDown countDownTime={countDownTime} />
          </div>
          <p className={styles.descr}>{anotherTimerDescr}</p>
          <NewYearSquirrel alt="squirrel" className={styles.squirrelImg} />
        </div>
      </div>
    )
  }

  if (isPawCitty) {
    return (
      <div className={styles.root}>
        <div className={styles.clsBtn}>
          <img src={closeBtn} className={styles.closeBtn} alt="closeBtn" />
        </div>
        <div className={styles.wrapper}>
          <img src={PawCitty} alt="" aria-hidden className={styles.pawImg} />
          <div className={styles.timer}>
            <CountDown countDownTime={countDownTime} />
          </div>
          <p className={styles.descr}>{timerDescription}</p>
        </div>
        <img src={BlueGift} alt="" aria-hidden className={styles.giftBlueImg} />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <div className={styles.clsBtn}>
        <img src={closeBtn} className={styles.closeBtn} alt="closeBtn" />
      </div>
      <div className={styles.wrapper}>
        {imgTimerType === "halva_card" ? (
          <HalvaCard alt="halva card" className={styles.cardImg} />
        ) : (
          <ClockImage alt="clock" className={styles.clockImg} />
        )}

        <div className={styles.timer}>
          <CountDown countDownTime={countDownTime} />
        </div>
        <p className={styles.descr}>{timerDescription}</p>
      </div>
      <GiftImage alt="gift" className={styles.giftImg} />
    </div>
  )
}

export default Timer
